module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_5010.ac639fd0.png";